import { OpenAI } from 'openai';
import { loadEnv } from '../../shims/load-env';
import METADATA from './metadata';

export const DEFAULT_OPENAI_MODEL = 'gpt-5.4-mini';

let _defaultOpenAIClient: OpenAI | undefined;
let _defaultOpenAIKey: string | undefined;
let _defaultTracingApiKey: string | undefined;

export function setTracingExportApiKey(key: string) {
  _defaultTracingApiKey = key;
}

export function getTracingExportApiKey(): string | undefined {
  return _defaultTracingApiKey ?? loadEnv().OPENAI_API_KEY;
}

export function setDefaultOpenAIClient(client: OpenAI) {
  _defaultOpenAIClient = client;
}

export function getDefaultOpenAIClient(): OpenAI | undefined {
  return _defaultOpenAIClient;
}

export function setDefaultOpenAIKey(key: string) {
  _defaultOpenAIKey = key;
}

export function getDefaultOpenAIKey(): string | undefined {
  return _defaultOpenAIKey ?? loadEnv().OPENAI_API_KEY;
}

export const HEADERS = {
  'User-Agent': `Agents/JavaScript ${METADATA.version}`,
};
